import { ElementType } from "react"
import { Ripple } from "../Ripple"
import type { ButtonProps } from "./ButtonProps"

import style from "./index.module.css"
import cx from "classix"
import { getRippleColorFromColorStyle } from "../../utils"

export type { ButtonProps }

/**
 * Кнопка. По умолчанию представляет собой обертку вокруг `button`. Помимо своих свойств, принимает свойства оборачиваемого элемента.
 */
export const Button = function Button<C extends ElementType = "button">({
																						elementType,
																						disabled = false,
																						colorStyle = "primary",
																						transparent = false,
																						fillable = false,
																						borderless = false,
																						children,
																						className,
																						...props
																					}: ButtonProps<C>) {


	const Component: ElementType = elementType ?? "button"

	return (
		<Component
				   className={cx(
					   style.button,
					   disabled && style.disabled,
					   borderless && style.borderless,
					   transparent && style.transparent,
					   fillable && style.fillable,
					   `cs-${colorStyle}`,
					   className)}
				   {...props}>
			<Ripple color={getRippleColorFromColorStyle(colorStyle)} />
			{children}
		</Component>
	)
}

Button.displayName = "Button"